import { fork } from 'redux-saga/effects';

export default function* saga(persistor, history) {
 const fullAppSaga = require('./full-app').default;
 yield fork(fullAppSaga, history);
}